// ./fe-build.sh  admain

import 'es6-promise/auto'
import Alram from './components/common/alram.vue';
import videoPlayer from './components/common/videoPlayerOne.vue';
import Vue from 'vue'
import Axios from 'axios'
import swal from 'sweetalert';
import mobile from 'is-mobile';

Vue.use(mobile);

Vue.component("alarm", Alram);
Vue.component('videoplayer', videoPlayer);
new Vue({
  el: '#mainpage',
  data: function () {
    return {
      loginUser: null,
      isRecommnend: false,
      isMobile: false,
      listBanner: [],
      meetRoomList: [],
      viewModel: {
        challengeHotList: [],
        imgList: [],
        homeBaseList: [],
        mainhomeBaseList: [],
        mainNewPrgmList: [],
        mainNewPrgmList2: [],
        mainHitPrgmList: [],
        mainHitPrgmList2: [],
        hotContents: {title: ' '},
        allContents: [{tesxt: ' '}],
        allContentSplitList: [], // 알통정보 두줄 출력을 위해서 allContents 를 필요한 것만 필터링 하고, 3개 및 그 이후 list 이렇게 두개로 나눔
        centerCnt: 0,
        programCnt: 0,
        homebaseCnt: 0
      },
      isMobileStyle: {'width': '100%', 'height': 'auto'},
      isMobileStyles: {'height': 'auto'},
      isMobileContentStyle: {'height': '100%'},
      basicOptions: {
        playerOptions: [{
          height: '360',
          autoplay: true,
          muted: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [{type: "video/mp4", src: "",}],
          poster: "",
        }, {
          height: '360',
          autoplay: true,
          muted: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [{type: "video/mp4", src: "",}],
          poster: "",
        }, {
          height: '360',
          autoplay: true,
          muted: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [{type: "video/mp4", src: "",}],
          poster: "",
        }]
      }
    }
  },
  created: function () {
    this.isMobile = mobile();
    this.fnOnCheckBanner();
    this.fnGetHomeBaseList();
    this.fnGetChallengeList();
  },
  mounted: function () {
    this.fnOnInit();
    try {
      pageLoadByAdMain(this) // pageLoadd() 는 이미 다른 vue 에서도 쓰고 있어서 겹치면 data 가 다르기 때문에 함수 이름을 다르게 함.
    } catch (e) {
      console.warn(`--- pageLoadByAdMain call fail : ${e}`)
    }
  },
  beforeDestroy: function () {
    this.fnOnCheckPopup();
  },
  methods: {
    fnOnInit: function () {
      //   this.fnOnLoginUserCheck();
      this.fnOnCheckPopup();
      this.fnGetChallengeList();
      this.fnGetHomeBaseList();
      this.fnGetMainHomeBaseList();
      this.fnGetProgramList();
      this.fnGetRealinfoList();
      this.fnGetMainAllCnt();
      this.fnGetMeetRoomList();
    },
    fnOnCheckPopup: function () {
      let vm = this;
      let _param = {
        uidKey: null,
        paramView: 'view'
      }
      let param = {
        paramText: JSON.stringify(_param),
        paramView: 'view'
      };

      let pageName = $("#pageName").val();

      Axios.post("/api/admin/popup/detail", param).then(function (response) {
        console.log(response);
        if (response.data.list.length > 0) {
          response.data.list.forEach(function (item) {
            let _uri = '/popup/view/' + item.uid;
            let _option = "top=500,left=500,width=" + item.width + ",height=" + item.height;
            let _name = "youthnavipop_" + (item.uid);

            if (pageName === "youthnaviMain") {
              var expChk = vm.getPopupCookie(_name);
              if (expChk < 0) {
                window.open(_uri, _name, _option);
              }
            } else {
              window.open(_uri, _name, _option);
            }

          });
        }

      }).catch(function (ex) {
        console.log(ex);
      })
    },
    getPopupCookie(name) {
      const cookieData = document.cookie;
      const expChk = cookieData.indexOf(name);
      return expChk;
    },
    // 이제 미사용 - 업데이트 방식 변경함
    // fnOnClickBanner: function (item) {
    //   let vm = this;
    //   let _param = {
    //     uidKey: item.uidKey,
    //     divide: 'custommer'
    //   }
    //   let param = {
    //     paramText: JSON.stringify(_param)
    //
    //   };
    //   Axios.post("/api/admin/banner/updateHit", param).then(function (response) {
    //     console.log(response);
    //
    //     /*   $(".banner_yard a").css("background-image", "url("+response.data.list[0].imagePath + "), url("+ response.data.list[1].imagePath +")");
    //       $(".banner_yard a").css("background-repeat",   "no-repeat");
    //       $(".banner_yard a").css("background-position", "top right");
    //       $(".banner_yard a").css("background-size",     "auto, cover"); */
    //   }).catch(function (ex) {
    //     console.log(ex);
    //   });
    // },
    fnOnCheckBanner: function () {
      let vm = this;
      let _param = {
        uidKey: 'BANNVLOCNV00100',
        divide: 'custommer'
      }
      let param = {
        pageNo: 0,
        pageSize: 10,
        paramText: JSON.stringify(_param),

      };

      Axios.post("/api/admin/banner/list", param).then(function (response) {
        vm.listBanner = response.data.list;

        /*   $(".banner_yard a").css("background-image", "url("+response.data.list[0].imagePath + "), url("+ response.data.list[1].imagePath +")");
          $(".banner_yard a").css("background-repeat",   "no-repeat");
          $(".banner_yard a").css("background-position", "top right");
          $(".banner_yard a").css("background-size",     "auto, cover"); */
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnOnLoginUserCheck: function () {
      let vm = this;
      Axios.post("/api/admin/user/init/check", {}).then(function (response) {
        vm.loginUser = response.data.commonParams;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnOnClickRecomendMessage: function () {
      this.fnOnLoadMessage();
    },
    fnOnLoadMessage: function (evt) {
      return this.isRecommnend = true;
    },
    //홈베이스 60초 챌린지 리스트
    fnGetChallengeList: function () {
      let vm = this;
      let param = {};
      param.pageNo = 1;
      param.pageSize = 3;
      //param.searchOrder = "hit";

      Axios.post("/customer/homebase/selectChallengeMainList", {homeBaseVo: param}).then(function (response) {
        console.log(response);
        let _list = response.data.list;
        let _lists = [];
        let _imgs = [];
        let _img = response.data.fileImgList;

        if (_list.length > 0) {
          _list.forEach(function (item, idx) {

            item.checked = false;
            // if(idx < 3){
            _lists.push(item);
            // }

          });
        }
        if (_img.length > 0) {
          _img.forEach(function (item, idx) {
            if (item == null || item.file_new_name == null) {
              _imgs.push(null);
            } else {
              item.img = '/video/' + item.file_new_name.substring(0, 8) + "/" + item.file_new_name.split(".")[0] + '.' + item.file_ext;
              item.video = "/video/" + item.file_new_name.substring(0, 8) + "/" + item.file_new_name.split(".")[0] + '.mp4';
              _imgs.push(item);
            }
          });
        }
        vm.viewModel.challengeHotList = _lists;
        vm.viewModel.imgList = _imgs;

      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnOnChangeMouseOver: function (item) {
      item.checked = true;
    },
    fnOnChangeMouseLeave: function (item) {
      item.checked = false;
    },
    fnGoContentsDetail: function (uid) { //동아리 컨텐츠 상세 페이지
      location.href = '/customer/homebase/contentsDetail?paramUid=' + uid;
    },
    fnGoHomeBaseDetail: function (uid) { //동아리 상세 페이지
      location.href = '/customer/homebase/homeBaseDetail?paramUid=' + uid;
    },
    //동아리 리스트 조회
    fnGetHomeBaseList: function () {
      let vm = this;
      let param = {};
      param.pageNo = 1;
      param.pageSize = 10;

      Axios.post("/customer/homebase/selectHomeBaseList", {homeBaseVo: param}).then(function (response) {
        vm.viewModel.homeBaseList = response.data.list;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    // mainhomeBaseList
    //동아리 리스트 조회
    fnGetMainHomeBaseList: function () {
      console.log("메인 동아리 조회");
      let vm = this;
      let param = {};
      param.pageNo = 1;
      param.pageSize = 10;

      Axios.post("/customer/homebase/selectMainHomeBaseList", {homeBaseVo: param}).then(function (response) {
        console.log("response.data.list : ", response.data.list);
        vm.viewModel.mainhomeBaseList = response.data.list;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGetProgramList: function () {
      let vm = this;
      let param = {};

      Axios.post("/api/expinfo/mainList", param).then(function (response) {


        vm.viewModel.mainNewPrgmList = [];
        vm.viewModel.mainNewPrgmList2 = [];
        vm.viewModel.mainHitPrgmList = [];
        vm.viewModel.mainHitPrgmList2 = [];

        response.data.expinfoList.forEach(function (item, idx) {
          item.isZzim = item.zzimYn !== null && item.zzimYn !== "N"
          if (idx < 3) { // 첫줄 3개
            vm.viewModel.mainHitPrgmList.push(item);
          } else { // 나머지 둘째줄
            vm.viewModel.mainHitPrgmList2.push(item);
          }
        });

        response.data.expinfoSubList.forEach(function (item, idx) {
          item.isZzim = item.zzimYn !== null && item.zzimYn !== "N"
          if (idx < 3) { // 첫줄 3개
            vm.viewModel.mainNewPrgmList.push(item);
          } else { // 나머지 둘째줄
            vm.viewModel.mainNewPrgmList2.push(item);
          }
        });
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGetAffClassName(item) {
      let affCode = "";
      switch (item) {
        case "인문과학"   : affCode = "dpt_label dpt01"; break;
        case "사회과학"   : affCode = "dpt_label dpt02"; break;
        case "상경"       : affCode = "dpt_label dpt03"; break;
        case "사범(교육)" : affCode = "dpt_label dpt04"; break;
        case "자연과학"   : affCode = "dpt_label dpt05"; break;
        case "공학"       : affCode = "dpt_label dpt06"; break;
        case "의학/보건"  : affCode = "dpt_label dpt07"; break;
        case "예체능"     : affCode = "dpt_label dpt08"; break;
        case "융합"       : affCode = "dpt_label dpt09"; break;
      }
      return affCode;
    },
    //찜하기 버튼
    fnInsertZzim(_item) {
      let _userKey = $("#usrKey").val();

      if (_userKey != null && _userKey != "") {
        _item.isZzim = !_item.isZzim
        _item.zzimYn = (_item.isZzim) ? 'Y' : 'N';

        let param = {
          programUid: _item.uidKey,
          zzimYn: _item.zzimYn
        };

        Axios.post("/api/expinfo/checkZzim", param).then(function (response) {
          let result = response.data.result;
        }).catch(function (ex) {
          alert("오류가 발생했습니다.");
          console.log(ex);
        });
      } else {
        swal({
          text: "찜하기는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          icon: this.fnOnLoadSwalImageData("info"),
          closeOnClickOutside: false,
          buttons: {
            confirm: {text: "확인", value: true,  visible: true},
            cancel:  {text: "취소", value: false, visible: true}
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login";
          }
        });
      }
    },
    fnGotoDetailP(uid) {
      location.href = "/customer/expinfo/detailExpinfo?uidKey=" + uid;
    },
    //태그 이미지, 스타일 삭제
    fnRemoveTag: function (value) {
      let content = value.replace(/<(\/a|a|\/img|img|\/style|style|\/br|br|\/p|p|\/span|span|\/strong|strong|\/h1|h1|\/h2|h2|\/h3|h3)([^>]*)>/gi, "");
      if (content == null) {
        return '';
      }
      return content;
    },
    //알통정보 조회
    fnGetRealinfoList: function () {
      const vm = this;
      const _param = {subGroup: '', tab: '1'}
      const param = {param: _param, pageNo: 1, pageSize: 3}
      Axios.post("/api/realinfo/mainpage/list", param).then(function (response) {
        const list = response.data.paramBrdDtoList
        vm.viewModel.allContents = list;

        // 필요한 것만 필터링
        const flist = list?.filter(item => item.category === 'BRDNVYTHNV00500' || item.subCategory === 'BRDNVYTHNV03000') || []
        if (flist?.length > 0) { // 필터링 결과가 있을때
          vm.viewModel.allContentSplitList = flist.length < 6 // 총 갯수 6개 이하면
            ? [flist] // 그냥 첫줄에 다 넣고
            : [flist.slice(0, 3), flist.slice(3)] // 6개 이상이면, 3개까지는 첫줄, 나머지는 둘째줄로
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //알통정보 상세페이지
    OnClickMentoDetailPage(uidKey) {
      location.href = "/customer/realinfo/content/detail?uidKey=" + uidKey;
    },
    //알통정보 더보기
    onclickMoreContentList() {
      location.href = "/customer/realinfo";
    },
    // e-포트폴리오 이동
    fnGoPortfolio() {
      let vm = this;
      if ($("#smlCode").val() != null && $("#smlCode").val() != "") {
        if ($("#smlCode").val() == 'USRNVYTHNV00110') { //청소년
          location.href = "/youthnavi/mypage/user/portFolio";
        } else {
          swal({
            text: '성인/기관 회원은 포트폴리오가 없습니다.',
            icon: vm.fnOnLoadSwalImageData('warning'),
            buttons: {
              cancel:  {text: "Cancel", value: false, visible: false,},
              confirm: {text: "Ok"    , value: true , visible: true,},
            },
            dangerMode: true
          });
          return false;
        }
      } else {
        swal({
          text: "로그인이 필요한 기능입니다.\n로그인하시겠습니까?",
          closeOnClickOutside: false,
          icon: fnOnLoadSwalImageData("info"),
          buttons: {
            confirm: {text: "확인", value: true , visible: true},
            cancel:  {text: "취소", value: false, visible: true}
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login";
          }
        });
      }
    },
    //alert 이미지 호출
    fnOnLoadSwalImageData: function (value) {
      return "/design/common/images/sub/img_alert_" + value + ".png";
    },
    //메인 하단 카운트
    fnGetMainAllCnt: function () {
      let vm = this;
      let param = {};

      Axios.post("/api/account/user/allCnt/list", param).then(function (response) {
        vm.viewModel.centerCnt = response.data.mainTotalCount.centerCnt;
        vm.viewModel.programCnt = response.data.mainTotalCount.programCnt;
        vm.viewModel.homebaseCnt = response.data.mainTotalCount.homebaseCnt;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    onClickGooroomee: function () { // 구루미 클릭
      let _userKey = $("#usrKey").val();
      if (_userKey != null && _userKey !== "") {
        Axios.post("/api/gooroomee/create_room", {})
          .then(function (response) {
            console.log(response.data.resultMessage)
            if (response.data.resultCnt > 0) { // 미팅룸 생성 성공
              const w = window.open(response.data.resultMessage, '_blank');
              try { w.focus(); } catch (e) { }
            } else {
              alert("구루미 미팅룸 생성에 실패하였습니다.");
            }
          }).catch(function (ex) {
          console.log(ex);
          alert("오류가 발생했습니다.");
        });
      } else {
        swal({
          text: "로그인이 필요한 기능입니다.\n로그인하시겠습니까?",
          icon: this.fnOnLoadSwalImageData("info"),
          closeOnClickOutside: false,
          buttons: {
            confirm: {text: "확인", value: true, visible: true},
            cancel:  {text: "취소", value: false, visible: true}
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login";
          }
        });
      }
    },
    fnGetMeetRoomList() { // 화상회의 목록 조회
      let vm = this;
      Axios.post("/api/meeting/main_list", {}).then(function (response) {
        vm.meetRoomList = response.data.meetingRoomList
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    joinMeet(roomCode) {
      let _uri = "/meeting/room/" + roomCode;
      let _option = "top=500,left=500,width=1200,height=1200";
      let _name = "youthnavi_mpop_meet";

      const {app_os} = getAgentDeviceInfo()
      if (app_os === "IOS") {
        location.href = _uri
        // } else if (app_os === "AOS") {
        //   location.href = _uri
      } else {
        if (mobile())
          window.open(_uri, _name, _option);
        else
          window.open(_uri, _name); // 2023-08-03 :: 구루미 기능 중 화면녹화 기능을 사용하기 위해 toolbar가 나오는 창으로 open.
      }
    }
  },
  filters: {
    currency: function (value) {
      let num = new Number(value);
      return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
    },
    changeMoment: function (date) {
      if (date === '') return '';
      let value = new Date(date);
      let year = value.getFullYear();
      let month = value.getMonth() + 1;
      let day = value.getDate();
      if (month < 10) month = '0' + month;
      if (day < 10) day = '0' + day;
      return year + '.' + month + '.' + day;
    }
  }
});
